import { useEffect, useState } from 'react';

import { decode } from 'he';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'next-share';

const SocialLinks = ({ post }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  const [fbUrl, setFbUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');
  const [linkedInUrl, setLinkedInUrl] = useState('');

  useEffect(() => {
    setCurrentUrl(window.location.href);
    setFbUrl(`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`);
    setTwitterUrl(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        post.title.rendered + ' ' + currentUrl
      )}`
    );
    setLinkedInUrl(
      `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${encodeURIComponent(
        post.title.rendered
      )}&summary=${post.excerpt.rendered}`
    );
  }, [currentUrl, post]);

  return (
    <div className="socials mb-0">
      <FacebookShareButton url={fbUrl} quote={decode(post.title.rendered)}>
        <span className="fa-brands fa-facebook" href={fbUrl}>
          <span className="sr-only">Facebook</span>
        </span>
      </FacebookShareButton>

      <TwitterShareButton url={twitterUrl} title={decode(post.title.rendered)}>
        <span className="fa-brands fa-twitter" href={twitterUrl}>
          <span className="sr-only">Twitter</span>
        </span>
      </TwitterShareButton>

      <LinkedinShareButton url={linkedInUrl}>
        <span className="fa-brands fa-linkedin" href={linkedInUrl}>
          <span className="sr-only">LinkedIn</span>
        </span>
      </LinkedinShareButton>
    </div>
  );
};

module.exports = SocialLinks;
